import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, finalize } from 'rxjs';
import {
  InvestmentsSummaryResponse,
  TotalInvestmentsAmount,
} from '@common/interfaces/investments-summary/investments-summary.interface';
import { API_ENDPOINTS } from '@common/utils/api-endpoints.const';

@Injectable({
  providedIn: 'root',
})
export class InvestmentsSummaryService {
  private readonly http = inject(HttpClient);

  /** Cached total investments amount. null = not yet fetched or invalidated. */
  readonly totalInvestmentsAmount = signal<TotalInvestmentsAmount | null>(null);

  /** Whether a fetch is in progress. */
  readonly isLoading = signal(false);

  /** Fetch the investments summary from the API and update the signal. */
  fetchSummary(): Observable<InvestmentsSummaryResponse> {
    this.isLoading.set(true);
    return this.http
      .get<InvestmentsSummaryResponse>(API_ENDPOINTS.INVESTMENTS_SUMMARY)
      .pipe(
        tap(response =>
          this.totalInvestmentsAmount.set(
            response.data.total_investments_amount
          )
        ),
        finalize(() => this.isLoading.set(false))
      );
  }
}
